import React from 'react';
import { addMinutes } from 'date-fns';
import { useHistory } from 'react-router-dom';
import DisplaySelectedUnitTimeFrame from '@components/SchedulePage/DisplaySelectedUnitTimeFrame/DisplaySelectedUnitTimeFrame';
import { useBlockEventConfig } from '@components/SchedulePage/utilities/useBlockEventConfig/useBlockEventConfig';
import { SurgeonEventProps } from '@components/SchedulePage/SurgeonEvent/SurgeonEventProps';
import { ScheduleEventType } from '@data/schedules/types/ScheduleEventType';
import { LinkMenu } from '@components/LinkMenu/LinkMenu';
import { LinkMenuOptionProps } from '@components/LinkMenu/LinkMenuOption/LinkMenuOption';
import { VisibilityOutlined } from '@material-ui/icons';
import { OfficeRoles } from '@interfaces/UserProfile/UserRoleEnum';
import { SurgeonEventContainer } from '@components/SchedulePage/SurgeonEvent/presentationComponents/SurgeonEventContainer';
import { SurgeonEventTitle } from '@components/SchedulePage/SurgeonEvent/presentationComponents/SurgeonEventTitle';
import { SurgeonEventInfo } from '@components/SchedulePage/SurgeonEvent/presentationComponents/SurgeonEventInfo';
import { SurgeonEventManageCaseMenuContainer }
	from '@components/SchedulePage/SurgeonEvent/presentationComponents/SurgeonEventManageCaseMenuContainer';
import { SurgeonEventProcedureToolTip }
	from '@components/SchedulePage/SurgeonEvent/presentationComponents/SurgeonEventProcedureToolTip';
import { CaseDetailsPageState, CaseDetailsSources } from '@interfaces/CaseDetails/CaseDetailsPageState';

export const SecondarySurgeonEvent: React.FC<SurgeonEventProps> = ({ eventInfo }) => {
	const { cardStyles } = useBlockEventConfig(eventInfo);
	const history = useHistory<CaseDetailsPageState>();

	const changeRoute = React.useCallback((path: string) => {
		history.push(path, { from: CaseDetailsSources.SdsAsSecondarySurgeon });
	}, [history]);

	const option: LinkMenuOptionProps[] = [
		{
			id: 'viewCaseDetails',
			label: 'View Detail',
			icon: VisibilityOutlined,
			onClick: () => changeRoute('/cases/' + eventInfo.id),
			order: 1,
			showForRoles: OfficeRoles,
		}
	];

	return (
		<SurgeonEventContainer style={cardStyles}>
			<SurgeonEventTitle isBlock={false}>
                Secondary Surgeon
			</SurgeonEventTitle>
			<SurgeonEventInfo bold>Primary: {eventInfo.primarySurgeon}</SurgeonEventInfo>
			<SurgeonEventProcedureToolTip title={eventInfo.procedure}>
				{eventInfo.procedure}
			</SurgeonEventProcedureToolTip>
			<DisplaySelectedUnitTimeFrame
				timeFrame={{
					start: eventInfo.startDate,
					end: eventInfo.end ? eventInfo.endDate : addMinutes(eventInfo.startDate, 30),
				}}
				variant="body2"
			/>
			{eventInfo.type === ScheduleEventType.SCHEDULED && <SurgeonEventInfo>{eventInfo.room}</SurgeonEventInfo>}
			<SurgeonEventManageCaseMenuContainer>
				<LinkMenu
					label="Manage Case"
					options={option}
					data-field="scheduling-secondary-surgeon-event-manageCaseMenu"
				/>
			</SurgeonEventManageCaseMenuContainer>
		</SurgeonEventContainer>
	);
};
